import dayjs from "dayjs";
import { ReportMimeType } from "../../../../../common/utils/report_callback";
import { IGetReportEntregaObraClienteSimplesUseCase } from "../../../presentation/useCases/read/get_report_entrega_obra_cliente_simples_use_case";
import { ReportData } from "../../models/report_data";
import { IReportsRepository } from "../../repositories/reports_repository";
import { downloadBase64File } from "../../../../../common/utils/download_utils";

/**
 * GetReportEntregaObraClienteSimplesUseCase
 */

export class GetReportEntregaObraClienteSimplesUseCase implements IGetReportEntregaObraClienteSimplesUseCase {
  constructor(private readonly repository: IReportsRepository) { }

  async execute(
    requiredMimeType: ReportMimeType | null,
    idEntregaObraCliente: number,
  ): Promise<ReportData> {
    const response = await this.repository.getReportEntregaObraClienteSimples(
      requiredMimeType,
      idEntregaObraCliente
    );

    if (response.mimeType !== 'text/html') {
      const arquivoNome = `entrega_obra_cliente_${dayjs(new Date()).format('DD_MM_YYYY_HH_mm_ss')}.${response.filenameExtension}`;
      const arquivo = response.bytes;

      await downloadBase64File(arquivoNome, arquivo);
    }
    return response;
  }

}
